import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";  // bootstrap i18n FR/EN avant rendu
import App from "@/App";

// Silence console.log/debug/warn en production — préserve console.error pour Sentry/debug critique.
// Cette stratégie évite de toucher individuellement les 7 fichiers contenant des console.* utiles en dev.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
  // console.error est conservé — utile pour le monitoring d'erreurs en prod
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
